export {
  default,
  default as RichText,
} from './RichText';
export type {
  RichTextBlockKey,
  RichTextBlockPropsMap,
  RichTextLinkBlockProps,
  RichTextProps,
  RichTextTypographyBlockKey,
  RichTextTypographyBlockProps,
} from './types';
export {
  BLOCK_COMPONENTS,
  DEFAULT_BLOCK_VARIANTS,
} from './types';
